import MeaButton from "../../../../components/MeaButton";
import { useAuthContext } from "../../../../hooks/useAuthContext";
import { ToFormatedDateWithWeekday } from "../../../../utils/dates";
import { useRef } from "react";
import UpdateRegistrationDroppoutDetailsModal from "../modals/UpdateRegistrationDroppoutDetailsModal";
import { Card } from "primereact/card";
import MeaMemberAvatar from "../../../../components/MeaMemberAvatar";
import { PERMISSION_TRAINING_REGISTRATION, PERMISSION_TRAINING_TASKS } from "../../../../permissions";
import RegistrationStepActions from "./RegistrationStepActions";

const RegistrationStepDroppoutComponent = ({ currentStudent, setCurrentStudent, callback, schoolId, trainingId }) => {

    const { hasPermission } = useAuthContext();
    const hasUpdateRegistrationsStatusPermission = hasPermission(PERMISSION_TRAINING_TASKS.UPDATE_REGISTRATIONS_STATUS)

    const updateRegistrationWaitingDetailsModalRef = useRef(null);

    const statusActionsRef = useRef(null);

    const footerTemplate = (options) => {
        const className = `${options.className} flex flex-wrap align-items-center justify-content-between`;
        return (
            <div className={className}>
                <div className="flex align-items-center gap-2">
                </div>
                <RegistrationStepActions
                    ref={statusActionsRef}
                    currentStudent={currentStudent}
                    schoolId={schoolId}
                    trainingId={trainingId}
                    callback={callback}
                    primary={{
                        label: "Re-candidater dans cette formation",
                        icon: "pi pi-replay",
                        severity: "danger",
                        outlined: true,
                        disabled: !hasUpdateRegistrationsStatusPermission,
                        onClick: () => statusActionsRef.current?.changeStatus("NEW"),
                    }}
                    items={[
                        {
                            label: "Mettre en liste d'attente",
                            icon: "pi pi-hourglass",
                            visible: hasUpdateRegistrationsStatusPermission,
                            command: () => statusActionsRef.current?.changeStatus("WAITING_LIST"),
                        },
                    ]}
                />
            </div>
        );
    };

    return (
        <>
            {(currentStudent?.status === "UNREGISTRED") &&
                <Card footer={footerTemplate} >
                    <ul className="list-none p-0 m-0">
                        <li className="flex align-items-center py-2 px-2 flex-wrap  ">
                            <div className="text-500 w-full md:w-5 font-medium text-left md:text-right">Depuis</div>
                            <div className="text-900 w-full pl-3 md:w-5">
                                <div className="w-full">{currentStudent?.unregistration_date ? ToFormatedDateWithWeekday(new Date(currentStudent?.unregistration_date)) : "-"}</div>
                            </div>
                        </li>
                        <li className="flex align-items-center py-2 px-2 flex-wrap ">
                            <div className="text-500 w-full md:w-5 font-medium text-left md:text-right">Désinscrit par</div>
                            <div className="text-900 w-full pl-3 md:w-7">
                                {currentStudent?.unregistration_by ? (
                                    <MeaMemberAvatar member={currentStudent?.unregistration_by} noNavigation={false} />
                                ) : (
                                    "-"
                                )}
                            </div>
                        </li>
                        <li className="flex align-items-center py-2 px-2 flex-wrap ">
                            <div className="text-500 w-full md:w-5 font-medium text-left md:text-right">Niveau</div>
                            <div className="text-900 w-full pl-3 md:w-7">
                                {currentStudent?.level?.name || currentStudent?.classe?.level?.name || "-"}
                            </div>
                        </li>
                        <li className="flex align-items-center py-2 px-2 flex-wrap ">
                            <div className="text-500 w-full md:w-5 font-medium text-left md:text-right">Classe</div>
                            <div className="text-900 w-full pl-3 md:w-7">
                                {currentStudent?.classe?.name || "-"}
                            </div>
                        </li>
                        <li className="flex align-items-center py-2 px-2 flex-wrap ">
                            <div className="text-500 w-full md:w-5 font-medium text-left md:text-right">Détails</div>
                            <div className="text-900 w-full pl-3 md:w-7">
                                <div className="flex justify-content-between flex-wrap align-items-center">
                                    <div className="w-10">{currentStudent?.unregistration_reason || "-"}</div>
                                    <div className="w-2"><MeaButton permission={PERMISSION_TRAINING_REGISTRATION.UPDATE} icon="pi pi-pencil" className="mr-2" size="small" text onClick={() => {
                                        if (updateRegistrationWaitingDetailsModalRef.current) {
                                            updateRegistrationWaitingDetailsModalRef.current.show(() => {
                                                callback?.();
                                            });
                                        }
                                    }} /></div>
                                </div>
                            </div>

                        </li>
                    </ul>

                </Card>}
            <UpdateRegistrationDroppoutDetailsModal ref={updateRegistrationWaitingDetailsModalRef} student={currentStudent} schoolId={schoolId} trainingId={trainingId} />
        </>
    );
}

export default RegistrationStepDroppoutComponent;